'use client';

import type { FC } from 'react';
import ReactPaginate from 'react-paginate';

type Props = {
  initialPage: number | null;
  onPageChange: React.ComponentProps<typeof ReactPaginate>['onPageChange'];
  hrefBuilder?: React.ComponentProps<typeof ReactPaginate>['hrefBuilder'];
  totalCount: number;
  pageSize: number;
};

export const Paginator: FC<Props> = ({
  initialPage,
  onPageChange,
  hrefBuilder,
  totalCount,
  pageSize,
}: Props) => {
  const pageCount = totalCount / pageSize;

  return pageCount <= 1 ? null : (
    <div id="pagination">
      <ReactPaginate
        hrefBuilder={hrefBuilder}
        nextLabel={
          <svg
            className="!ui-w-2 !ui-max-h-none !ui-max-w-none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 512"
          >
            <path
              className="!ui-fill-black"
              d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
            />
          </svg>
        }
        onPageChange={onPageChange}
        pageRangeDisplayed={10}
        marginPagesDisplayed={2}
        forcePage={initialPage || undefined}
        pageCount={pageCount}
        activeLinkClassName="ui-bg-gray-300 ui-rounded-md"
        previousLabel={
          <svg
            className="!ui-w-2 !ui-max-h-none !ui-max-w-none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 512"
          >
            <path
              className="!ui-fill-black"
              d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
            />
          </svg>
        }
        pageClassName=""
        pageLinkClassName="ui-h-8 ui-w-8 ui-flex ui-items-center ui-justify-center ui-shrink-0 !ui-font-normal !ui-text-black ui-select-none"
        previousClassName="ui-mr-2"
        previousLinkClassName=""
        nextClassName="ui-ml-2"
        nextLinkClassName=""
        breakLabel="..."
        breakClassName=""
        breakLinkClassName=""
        containerClassName="ui-flex ui-items-center ui-justify-end ui-gap-1 !ui-list-none"
        activeClassName="active"
        renderOnZeroPageCount={undefined}
      />
    </div>
  );
};
